import ProductDetails from "../components/Product/details";

const ProductDetailsPage = () => {
  return <ProductDetails />;
};

export default ProductDetailsPage;
